import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { FileQueryParams, Result, ResultQueryParams } from '../models/result.model';

export abstract class ResultGateway {
  abstract listResults(params: ResultQueryParams): Observable<ListResponse<Result>>;
  abstract getFile(params: FileQueryParams): Observable<{ url: string }>;
}
